import { RegulationDocument } from 'components/common-form/sidePanel/docToolbar/regulatory/model';
import { useAppSelector } from 'hooks/useAppSelector';
import { createSelector } from 'reselect';
import type { AppState } from 'state/state.model';
import { WorkspaceType } from 'state/workspaces/model';

import { RawDocuments } from './RawDocuments';
import { getQuoteRegulationInfosSelector, asDocuments } from './selector';

const getDocuments: (state: AppState, workspaceType: WorkspaceType, tabId: string) => RegulationDocument[] =
  createSelector([getQuoteRegulationInfosSelector], regulationInfos => {
    return asDocuments(regulationInfos?.kidDocument ?? []);
  });

const getDocumentHasErrors: (state: AppState, workspaceType: WorkspaceType, tabId: string) => boolean = createSelector(
  [getQuoteRegulationInfosSelector],
  regulationInfos => {
    return (regulationInfos?.kidDocumentError?.length ?? 0) > 0 || (regulationInfos?.kidDocumentTimeout ?? false);
  },
);

export function KidDocumentsLegacy({ tabId, workspaceType }: { tabId: string; workspaceType: WorkspaceType }) {
  const documents = useAppSelector(state => getDocuments(state, workspaceType, tabId));
  const hasErrors = useAppSelector(state => getDocumentHasErrors(state, workspaceType, tabId));

  return (
    <RawDocuments
      event="Download KID language"
      documents={documents}
      hasErrors={hasErrors}
      labelKey="form.buttons.KidDocuments"
      e2e="download-kid-doc"
    />
  );
}
